import field_options from '../../constants/field_options.constats';

export default class PackagesNativeController {
	constructor($state, $scope, PackagesDAO, $q, FooterDao, ArtifactoryFeatures, User, ArtifactoryStorage) {
		this.$state = $state;
		this.$scope = $scope;
		this.$q = $q;
		this.packagesDAO = PackagesDAO;
		this.footerDao = FooterDao;
		this.artifactoryStorage = ArtifactoryStorage;

		if (User.currentUser.name === 'anonymous' && !User.currentUser.anonAccessEnabled) {
			$state.go('login');
			return;
		}
		if (ArtifactoryFeatures.isOss()) {
			$state.go('home');
			return;
		}

/*
        this.disabledPackageTypes = [];
		if (!localStorage._enableNativeNpm) this.disabledPackageTypes.push('npm');
*/

		this.hostData = {
            getPackageTypes: () => this.getPackageTypes(),
            isXrayEnabled: () => this.isXrayEnabled(),
            showExtraInfo: () => this.showExtraInfo(),

            getRepos: (params) => this.getRepos(params),
            getPackages: (params) => this.getPackages(params),
            getPackagesCount: (params) => this.getPackagesCount(params),
            getPackage: (params) => this.getPackage(params),
            getVersion: (params) => this.getVersion(params),
            getVersionData: (params) => this.getVersionData(params),
            getPackageExtraInfo: (params) => this.getPackageExtraInfo(params),
            getVersionExtraInfo: (params) => this.getVersionExtraInfo(params),
            getPackageSummary: (params) => this.getPackageSummary(params),
            getVersionSummary: (params) => this.getVersionSummary(params),
            getPackageSummaryExtraInfo: (params) => this.getPackageSummaryExtraInfo(params),
            getVersionSummaryExtraInfo: (params) => this.getVersionSummaryExtraInfo(params),
            getPackageDownloadsCount: (params) => this.getPackageDownloadsCount(params),
            getVersionDownloadsCount: (params) => this.getVersionDownloadsCount(params),
            getManifest: (params) => this.getManifest(params),

            cancelPackageExtraInfo: () => this.cancelPackageExtraInfo(),
            cancelVersionExtraInfo: () => this.cancelVersionExtraInfo(),

            showInTree: (params) => this.showInTree(params),
        }
	}

	getPackageTypes() {
		let defferd = this.$q.defer();
		let pkgTypes = field_options.repoPackageTypes.map((t) => {
			return {
				value: t.value,
				displayText: t.text,
				iconClass: `icon-${t.icon}`
			};
		});
		defferd.resolve(pkgTypes);
		return defferd.promise;
	}

	getPackages(params) {
        return this.packagesDAO.getPackages(params.pathAndQuery, params.payload).$promise;
	}

	getPackagesCount(params) {
        return this.packagesDAO.getPackagesCount(_.extend(params.pathAndQuery,{$no_spinner: true}), params.payload).$promise;
	}

	getRepos(params) {
		return this.packagesDAO.getRepos(params.pathAndQuery).$promise;
	}

	getPackage(params) {
        return this.packagesDAO.getPackage(params.pathAndQuery, params.payload).$promise;
	}

	getPackageSummary(params) {
        return this.packagesDAO.getPackageSummary(params.pathAndQuery, params.payload).$promise;
	}
	getPackageSummaryExtraInfo(params) {
        return this.packagesDAO.getPackageSummaryExtraInfo(_.extend(params.pathAndQuery,{$no_spinner: true}), params.payload).$promise;
	}

	getPackageExtraInfo(params) {
	    if (params.pathAndQuery.packageType === 'docker') {
            return this.packagesDAO.getDockerPackageExtraInfo(_.extend(params.pathAndQuery,{$no_spinner: true})).$promise;
        }
        else {
            return this.packagesDAO.getPackageExtraInfo(_.extend(params.pathAndQuery,{$no_spinner: true}), params.payload).$promise;
        }
	}

	getVersionExtraInfo(params) {
		return this.packagesDAO.getVersionExtraInfo(_.extend(params.pathAndQuery,{$no_spinner: true}), params.payload).$promise;
	}

    cancelPackageExtraInfo() {
	    this.packagesDAO.$cancelAll('getPackageExtraInfo');
    }

    cancelVersionExtraInfo() {
	    this.packagesDAO.$cancelAll('getVersionExtraInfo');
    }

	getPackageDownloadsCount(params) {
		return this.packagesDAO.getPackageDownloadsCount(_.extend(params.pathAndQuery,{$no_spinner: true})).$promise;
	}

	getVersionDownloadsCount(params) {
		return this.packagesDAO.getVersionDownloadsCount(_.extend(params.pathAndQuery,{$no_spinner: true})).$promise;
	}

	getManifest(params) {
		return this.packagesDAO.getManifest(params.pathAndQuery).$promise;
	}

	getVersion(params) {
		return this.packagesDAO.getVersion(params.pathAndQuery).$promise;
	}

	getVersionData(params) {
		return this.packagesDAO.getVersionData(_.extend(params.pathAndQuery,{$no_spinner: true})).$promise;
	}

    getVersionSummary(params) {
        return this.packagesDAO.getVersionSummary(params.pathAndQuery, params.payload).$promise;
    }

    getVersionSummaryExtraInfo(params) {
        return this.packagesDAO.getVersionSummaryExtraInfo(_.extend(params.pathAndQuery,{$no_spinner: true}), params.payload).$promise;
    }


	// TODO: When the product team will decide on phase 2 (adding xray) , replace the 'false' value
	isXrayEnabled() {
		return this.footerDao.get(false).then((footerData) => {
			return false;//footerData.xrayEnabled && footerData.xrayConfigured && footerData.xrayLicense;
		});
	}

    showExtraInfo() {
        return this.packagesDAO.showExtraInfo().$promise;
    }

	showInTree(pathParams) {
		let browser = this.artifactoryStorage.getItem('BROWSER') || 'tree';
		if (browser === 'stash') {
			browser = 'tree';
		}

        let path = pathParams.fullpath || `${pathParams.repo}/${pathParams.package}/${pathParams.version}`;

		this.$state.go('artifacts.browsers.path', {
			tab: 'General',
			artifact: path,
			browser: browser
		});
	}
}



// WEBPACK FOOTER //
// ./states/package_native/native.controller.js